import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
export const receiptFooterStyles = ({ theme, $colorContext, }) => css `
	background-color: ${$colorContext === 'on-light'
    ? theme.colors.blanc.bgReceipt
    : theme.colors.blanc.bgReceiptOnMedium};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		margin-top: ${pxToRem(theme.spacing[400])};
		background-color: unset;
	}
`;
export const StyledReceiptFooter = styled.footer `
	${receiptFooterStyles}
`;
